import SingleSelectFieldReadView, { singleSelectFieldRenderReadView } from './main';

export { singleSelectFieldRenderReadView };
export default SingleSelectFieldReadView;
